import { cn } from '@/lib/utils';

interface CharacterCounterProps {
  count: number;
  /** The hard maximum shown as `n/max`. */
  max: number;
  /**
   * Soft threshold at which the counter turns destructive. Defaults to `max`
   * (i.e. only goes red when over the hard limit). Pass a lower value to flag
   * a stricter advisory limit while still displaying headroom up to `max`.
   */
  warningAt?: number;
  className?: string;
}

export const CharacterCounter = ({
  count,
  max,
  warningAt = max,
  className,
}: CharacterCounterProps) => {
  const isOverLimit = count > warningAt;
  return (
    <span
      className={cn(
        'text-xs leading-4',
        isOverLimit ? 'text-destructive' : 'text-foreground-muted',
        className
      )}
    >
      {count}/{max}
    </span>
  );
};
